import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[letterNumberDot]'
})
export class LetterNumberDotDirective {
  @Input('letterNumberDot') validationType: 'letters' | 'lettersNumberDot' = 'letters';

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onInputChange(event: any) {
    let input = this.el.nativeElement.value;

    if (this.validationType === 'letters') {
      input = input.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g, '');
    } else if (this.validationType === 'lettersNumberDot') {
      input = input.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s.]/g, '');
    }

    this.el.nativeElement.value = input;
    event.target.value = input;
  }
}
